// extracted by mini-css-extract-plugin
export default {"container":"tvShows_container__Rqlss","tv_serie_container":"tvShows_tv_serie_container__M-T6p"};